import { useQuery } from '@tanstack/react-query';
import * as actions from './actions';

export function useCarePlanConditions() {
  return useQuery(['care-plan-conditions'], () => actions.findCarePlanConditions());
}